<template>
    <b-container>
        <h4 class="mt-4 p-2 text-center text-primary text-uppercase">Tipo de Cambio</h4>
        <b-row class="justify-content-center">
            <b-col cols="12" lg="3" class="mt-4 mb-2 d-none d-lg-block">
                <b-button variant="default" pill block size="sm" title="Agregar" @click="infoData" v-b-modal.data>
                    <i class="material-icons mdi mdi-cash-plus"></i>&nbsp;
                    <span>Nuevo Tipo de Cambio</span>
                </b-button>
            </b-col>
            <b-col cols="12" lg="9" class="mt-4 mb-2">
                <b-form-group class="mb-0">
                    <b-input-group size="sm">
                        <b-form-input id="search" v-model="search" type="search" placeholder="Buscar" class="pad-3-15 btlr-30 bblr-30"></b-form-input>

                        <b-input-group-append>
                            <b-button variant="default" :disabled="!search" @click="search = ''" class="m-0 btlr-0 bblr-0">
                                <i class="material-icons mdi mdi-close"></i>
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" class="px-0">
                <b-table
                    :items="items"
                    :fields="fields"
                    responsive="sm"
                    class="my-2 border-bottom"
                    stacked="sm"
                    hover
                    small
                    show-empty
                    no-border-collapse
                    table-variant="light"
                    details-td-class="px-0"
                    empty-filtered-text="No hay tasas que coincidan con la búsqueda"
                    empty-text="No hay tasas para mostrar"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :filter="search"
                    :busy="isBusy"
                    @filtered="onFiltered">
                    <template #cell(value)="row">
                        {{ Number(row.item.value).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 8 }) }}
                    </template>

                    <template #cell(status)="row">
                        <b-button pill variant="success" title="Activado" @click="active(row.item.id, 0)" v-if="row.item.status === 1">
                            <i class="material-icons">star</i>
                        </b-button>
                        <b-button pill variant="danger" title="Desactivado" @click="active(row.item.id, 1)" v-else>
                            <i class="material-icons">star_outline</i>
                        </b-button>
                    </template>

                    <template #cell(actions)="row">
                        <b-button variant="default" size="sm" title="Editar" @click="infoData(row.item.id)" v-b-modal.data>
                            <i class="material-icons">edit</i>
                        </b-button>
                        <b-button variant="danger" size="sm" title="Eliminar" @click="trash(row.item.id)">
                            <i class="material-icons">delete</i>
                        </b-button>
                    </template>

                    <template #table-busy>
                        <div class="text-center text-danger my-4">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Actualizando...</strong>
                        </div>
                    </template>
                </b-table>

                <!-- Modal Add/Edit Rate -->
                <b-modal
                    id="data"
                    centered
                    no-fade
                    header-class="text-center"
                    header-bg-variant="primary"
                    header-text-variant="light"
                    header-close-variant="light"
                    footer-class="border-0"
                    hide-footer
                    body-class="text-center px-4 my-4"
                    :title="(form.id ? 'Actualizar' : 'Agregar Nueva') + ' Tasa de Cambio'"
                    tabindex="-1"
                    role="dialog"
                    size="lg"
                    aria-hidden="true">
                    <b-form id="formData" @submit.stop.prevent="form.id !== 0 ? save(form.id) : save()">
                        <b-row class="justify-content-center">
                            <template v-for="(v, k) in form.values">
                                <b-col cols="12" md="10" align-self="start" v-if="form.values[k].key === 'code_send' || form.values[k].key === 'country_send'">
                                    <h6 class="pt-2">
                                        <u>{{ form.values[k].key === 'code_send' ? 'Monedas' : 'Paises' }}</u>
                                    </h6>
                                </b-col>
                                <b-col cols="12" md="5" align-self="start">
                                    <b-form-group :label="labels.values[k].name+':'" v-if="form.values[k].items">
                                        <b-form-select
                                            :name="'value' + k"
                                            :options="form.values[k].items"
                                            :value="form.values[k].value"
                                            v-model="form.values[k].value"
                                            class="form-control text-center"
                                            v-validate="(form.values[k].key === 'branch_id' || form.values[k].key === 'country_receiver' ? '' : 'required:true')"
                                            :state="validateState('value' + k)"
                                            :data-vv-as="(labels.values[k].name).toLowerCase()"
                                            :disabled="loading"
                                            :aria-describedby="'value' + k + '-live-feedback'"
                                            value-field="code"
                                            text-field="name"
                                        ></b-form-select>
                                        <b-form-invalid-feedback :id="'value' + k + '-live-feedback'">
                                            {{ veeErrors.first('value' + k) }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                    <b-form-group :label="labels.values[k].name+':'" v-else-if="form.values[k].key === 'value'">
                                        <b-form-input
                                            :name="'value' + k"
                                            v-model="form.values[k].value"
                                            type="number"
                                            inputmode="numeric"
                                            step="0.00000001"
                                            class="text-center"
                                            v-validate="'required:true'"
                                            :state="validateState('value' + k)"
                                            :data-vv-as="(labels.values[k].name).toLowerCase()"
                                            :disabled="loading"
                                            :aria-describedby="'value' + k + '-live-feedback'"/>
                                        <b-form-invalid-feedback :id="'value' + k + '-live-feedback'">
                                            {{ veeErrors.first('value' + k) }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                    <b-form-group :label="labels.values[k].name+':'" v-else>
                                        <b-form-input
                                            :name="'value' + k"
                                            v-model="form.values[k].value"
                                            type="text"
                                            class="text-center"
                                            v-validate="'required:true'"
                                            :state="validateState('value' + k)"
                                            :data-vv-as="(labels.values[k].name).toLowerCase()"
                                            disabled
                                            :aria-describedby="'value' + k + '-live-feedback'"/>
                                        <b-form-invalid-feedback :id="'value' + k + '-live-feedback'">
                                            {{ veeErrors.first('value' + k) }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </b-col>
                            </template>
                        </b-row>
                        <b-row class="justify-content-center">
                            <b-col cols="12" md="10" align-self="start" class="my-4">
                                <b-button type="submit" variant="default" size="lg" pill class="align-middle px-5"
                                          form="formData" :disabled="loading">
                                    <b-spinner small type="grow" v-if="loading"></b-spinner>
                                    <b-icon icon="upload" aria-hidden="true" class="align-middle" v-else></b-icon>
                                    &nbsp;&nbsp;<span>{{ loading ? (form.id === 0 ? 'Guardando...' : 'Actualizando...') : (form.id === 0 ? 'Guardar' : 'Actualizar' ) }}</span>
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-modal>
            </b-col>
            <b-col sm="5" md="6">
                <b-form-group
                    label="Mostrar:"
                    label-for="per-page-select"
                    label-cols-sm="4"
                    label-cols-md="6"
                    label-cols-lg="9"
                    label-align-sm="right"
                    label-size="sm"
                    class="mt-2 mb-8">
                    <b-form-select
                        id="per-page-select"
                        v-model="perPage"
                        :options="pageOptions"
                        size="sm"
                    ></b-form-select>
                </b-form-group>
            </b-col>
            <b-col sm="7" md="6">
                <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    align="fill"
                    size="sm"
                    class="mt-2 mb-8"
                ></b-pagination>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import axios from "axios";

export default {
    name: "PartnerRate",
    props: ['user'],
    data: () => ({
        labels: {
            values: [
                { key: 'type', name: 'Categoría' },
                { key: 'branch_id', name: 'Sucursal' },
                { key: 'value', name: 'Valor' },
                { key: 'code_send', name: 'Enviador (ISO 20022)' },
                { key: 'code_receiver', name: 'Receptor (ISO 20022)' },
                { key: 'country_send', name: 'Enviador (ISO 2)' },
                { key: 'country_receiver', name: 'Receptor (ISO 2)' }
            ]
        },
        form: {
            id: 0,
            type: 'sell',
            branch_id: null,
            value: 0,
            code_send: 'CLP',
            code_receiver: 'USD',
            country_send: 'CL',
            country_receiver: null,
            values: [
                { key: 'type', value: 'sell', items: [
                        { code: 'sell', name: 'Enviador (Venta)' }
                    ]
                },
                { key: 'branch_id', value: null, items: [] },
                { key: 'value', value: 0 },
                { key: 'code_send', value: 'CLP' },
                { key: 'code_receiver', value: 'USD' },
                { key: 'country_send', value: 'CL' },
                { key: 'country_receiver', value: null, items: [
                        { code: null, name: '_Cualquiera_' },
                        { code: 'AR', name: 'Argentina' },
                        { code: 'BO', name: 'Bolivia' },
                        { code: 'BR', name: 'Brasil' },
                        { code: 'CO', name: 'Colombia' },
                        { code: 'DE', name: 'Alemania' },
                        { code: 'DO', name: 'Rep. Dominicana' },
                        { code: 'EC', name: 'Ecuador' },
                        { code: 'ES', name: 'España' },
                        { code: 'FR', name: 'Francia' },
                        { code: 'HT', name: 'Haiti' },
                        { code: 'IT', name: 'Italia' },
                        { code: 'PE', name: 'Perú' },
                        { code: 'US', name: 'Estados Unidos' },
                        { code: 'VE', name: 'Venezuela' }
                    ]
                }
            ]
        },
        loading: false,
        isBusy: true,
        search: '',
        fields: [
            { key: 'id', label: 'ID', sortable: false, thClass: 'text-sm-right', tdClass: 'text-sm-right' },
            { key: 'branch_text', label: 'Sucursal', sortable: false },
            { key: 'type_text', label: 'Categoría', sortable: false },
            { key: 'value', label: 'Valor', sortable: false },
            { key: 'code', label: 'Moneda', sortable: false },
            { key: 'country', label: 'País', sortable: false },
            { key: 'status', label: 'Estado', sortable: false },
            { key: 'actions', label: 'Acción', sortable: false, thClass: 'text-sm-center', tdClass: 'text-sm-center' }
        ],
        items: [],
        totalRows: 1,
        currentPage: 1,
        perPage: 25,
        pageOptions: [25, 50, 100, { value: -1, text: "Todos" }],
        branches: []
    }),
    mounted() {
        this.$emit('loader');
        this.$emit('section', 'partnerratepage');
        this.totalRows = this.items.length;
        this.getIni();
    },
    watch: {
        'user.partner'() {
            this.getIni();
        }
    },
    methods: {
        getIni() {
            axios.get('/api/partner/settings/rate').then((res) => {
                if (res.data.status === 'success') {
                    this.items = res.data.items;
                    this.branches = res.data.branches;
                    this.totalRows = this.items.length;
                }
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            }).then(() => {
                this.isBusy = false;
            });
        },
        infoData(id) {
            this.form = {
                id: 0,
                type: 'sell',
                branch_id: null,
                value: 0,
                code_send: 'CLP',
                code_receiver: 'USD',
                country_send: 'CL',
                country_receiver: null,
                values: [
                    { key: 'type', value: 'sell', items: [
                            { code: 'sell', name: 'Enviador (Venta)' }
                        ]
                    },
                    { key: 'branch_id', value: this.user.branch, items: this.branches },
                    { key: 'value', value: 0 },
                    { key: 'code_send', value: 'CLP' },
                    { key: 'code_receiver', value: 'USD' },
                    { key: 'country_send', value: 'CL' },
                    { key: 'country_receiver', value: null, items: [
                            { code: null, name: '_Cualquiera_' },
                            { code: 'AR', name: 'Argentina' },
                            { code: 'BO', name: 'Bolivia' },
                            { code: 'BR', name: 'Brasil' },
                            { code: 'CO', name: 'Colombia' },
                            { code: 'DE', name: 'Alemania' },
                            { code: 'DO', name: 'Rep. Dominicana' },
                            { code: 'EC', name: 'Ecuador' },
                            { code: 'ES', name: 'España' },
                            { code: 'FR', name: 'Francia' },
                            { code: 'HT', name: 'Haiti' },
                            { code: 'IT', name: 'Italia' },
                            { code: 'PE', name: 'Perú' },
                            { code: 'US', name: 'Estados Unidos' },
                            { code: 'VE', name: 'Venezuela' }
                        ]
                    }
                ]
            };
            if (id) {
                const items = this.items;

                for (let i = 0; i < items.length; i++) {
                    if (items[i].id === id) {
                        this.form = items[i];
                    }
                }
            }
        },
        save(id) {
            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }
                this.loading = true;
                let url = 'add';
                if (id) {
                    url = id + '/edit';
                }
                let formData = new FormData();
                formData.append('id', this.form.id);
                formData.append('values', JSON.stringify(this.form.values));
                axios.post('/api/partner/settings/rate/' + url, formData, {
                    headers: {'Content-Type': 'application/x-www-form-urlencoded'}
                }).then((res) => {
                    this.$root.$bvToast.toast(res.data.msg, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: res.data.status,
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                    if (res.data.status === 'success') {
                        this.getIni();
                        this.$bvModal.hide('data');
                        this.infoData();
                        this.$validator.reset();
                    }
                }).catch(err => {
                    this.$root.$bvToast.toast(err.response.data.errors, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: 'error',
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                }).then(() => {
                    this.loading = false;
                });
            });
        },
        active(id, status) {
            let code = '';
            let country = '';
            const items = this.items;

            for (let i = 0; i < items.length; i++) {
                if (items[i].id === id) {
                    code = items[i].code;
                    country = items[i].country;
                }
            }

            this.$swal({
                title: '¿Estas seguro de ' + (status === 1 ? 'activar' : 'desactivar') + ' esta tasa de cambio?',
                html: 'ID: ' + id + '<br>' + code + '<br>' + country,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si, ' + (status === 1 ? 'activar' : 'desactivar'),
                confirmButtonColor: '#28a745',
                cancelButtonText: 'En otro momento',
                cancelButtonColor: '#dc3545',
                allowOutsideClick: false,
                allowEscapeKey: false,
                reverseButtons: true
            }).then((result) => {
                if (result.value) {
                    axios.get('/api/partner/settings/rate/' + id + '/' + status).then((res) => {
                        if (res.data.status === 'success') {
                            for (let i = 0; i < items.length; i++) {
                                if (items[i].id === id) {
                                    items[i].status = status;
                                }
                            }
                            this.items = items;
                        }
                    }).catch(err => {
                        this.$root.$bvToast.toast(err.response.data.errors, {
                            title: 'Notificación',
                            headerClass: 'd-none',
                            variant: 'error',
                            toaster: 'b-toaster-top-right',
                            autoHideDelay: 5000,
                            solid: true,
                            appendToast: true
                        });
                    });
                }
            });
        },
        trash(id) {
            let code = '';
            let country = '';
            const items = this.items;

            for (let i = 0; i < items.length; i++) {
                if (items[i].id === id) {
                    code = items[i].code;
                    country = items[i].country;
                }
            }

            this.$swal({
                title: '¿Estas seguro de eliminar esta tasa de cambio?',
                html: 'ID: ' + id + '<br>' + code + '<br>' + country,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si, eliminar',
                confirmButtonColor: '#28a745',
                cancelButtonText: 'En otro momento',
                cancelButtonColor: '#dc3545',
                allowOutsideClick: false,
                allowEscapeKey: false,
                reverseButtons: true
            }).then((result) => {
                if (result.value) {
                    axios.get('/api/partner/settings/rate/' + id + '/delete').then((res) => {
                        if (res.data.status === 'success') {
                            for (let i = 0; i < items.length; i++) {
                                if (items[i].id === id) {
                                    items.splice( i, 1 );
                                    this.totalRows = this.items.length;
                                }
                            }
                        }
                    }).catch(err => {
                        this.$root.$bvToast.toast(err.response.data.errors, {
                            title: 'Notificación',
                            headerClass: 'd-none',
                            variant: 'error',
                            toaster: 'b-toaster-top-right',
                            autoHideDelay: 5000,
                            solid: true,
                            appendToast: true
                        });
                    });
                }
            });
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        validateState(ref) {
            if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        resetValidationState() {
            this.isValid = undefined
        }
    }
}
</script>

<style scoped>

</style>
